export const SecondsAutomaticUpdate: number = 60;

export const PortletDraggableOptions: object = {
    items: ".kt-portlet",
    opacity: 0.8,
    handle: ".kt-portlet__head",
    coneHelperSize: true,
    placeholder: "kt-portlet--sortable-placeholder",
    forcePlaceholderSize: true,
    tolerance: "pointer",
    helper: "clone",
    dropOnEmpty: true,
    cancel: ".kt-portlet--sortable-empty",
    revert: 250,
    update: (b: any, c: any) => {
        if (c.item.prev().hasClass("kt-portlet--sortable-empty")) {
            c.item.prev().before(c.item);
        }
    },
    receive: (event: any, ui: any) => {
        if ($(ui.sender).children().length < 2) {
            $(ui.sender).prepend($(event.target).children().not($(ui.item)).last());
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Dashboards/Dashboard.ts